var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card card-alert",
      class: [_vm.readonly === true ? "readOnly" : "normalMode"],
    },
    [
      _c("div", { staticClass: "card-inner" }, [
        _vm.sounds && _vm.sounds.volume && _vm.sounds.authorization
          ? _c("div", { staticClass: "card-row" }, [
              _c("div", { staticClass: "title-container" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("profile.sound_effect.prealert.title")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-container" }, [
                _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("profile.sound_effect.prealert.volume")) +
                      ": " +
                      _vm._s(_vm.sounds.volume.value) +
                      "%\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "range-input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sounds.volume.value,
                        expression: "sounds.volume.value",
                      },
                    ],
                    staticClass: "form-input",
                    class: { "over-threshold": _vm.sounds.volume.value < 60 },
                    attrs: {
                      type: "range",
                      disabled: _vm.readonly,
                      min: _vm.sounds.volume.values.min,
                      max: _vm.sounds.volume.values.max,
                      step: _vm.sounds.volume.values.step,
                    },
                    domProps: { value: _vm.sounds.volume.value },
                    on: {
                      change: function ($event) {
                        return _vm.modification("config")
                      },
                      __r: function ($event) {
                        return _vm.$set(
                          _vm.sounds.volume,
                          "value",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sounds.volume.value < 60,
                        expression: "sounds.volume.value < 60",
                      },
                    ],
                    staticClass: "volume-warning",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("profile.sound_effect.prealert.volume_warning")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "switch-input" },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        staticClass: "switcher",
                        attrs: {
                          disabled: _vm.readonly,
                          value: "1",
                          "unchecked-value": "0",
                          switch: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.modification("config")
                          },
                        },
                        model: {
                          value: _vm.sounds.authorization.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.sounds.authorization, "value", $$v)
                          },
                          expression: "sounds.authorization.value",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "profile.sound_effect.prealert.volume_adjustable"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.sounds.authorization.value == 1
                      ? _c("div", { staticClass: "switch-input__warning" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "profile.sound_effect.prealert.volume_adjustable_warning"
                                )
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", {
        staticClass: "fa fa-volume-up",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }